/**
 * @file CartWarnings.tsx
 * @description Предупреждения под полем «Вида корзины» (phase19.16, SB120
 * этап 4; db-design-sb120-stage4 §1.3, uiux-cart §4): `cartLookWarnings` с
 * путём поля — словами владельца. Предупреждение, не запрет: значение
 * сохраняется. Контраст показывает само поле цвета (число и «Взять
 * читаемый») — здесь его нет (`warningsAt`).
 */

import { SITE_CART_WARNING_MESSAGES } from "@chaiberi/shared";

import { NoticeStrip } from "../../ui/NoticeStrip";
import { useCartLook } from "./cart-look-context";
import { warningsAt } from "../../../lib/site-view/cart-look";

export function CartWarnings({ path }: { path: string }) {
  const { warnings } = useCartLook();
  const list = warningsAt(warnings, path);
  if (list.length === 0) return null;
  return (
    <>
      {list.map((w) => (
        <NoticeStrip key={w.code} tone="warning">
          {SITE_CART_WARNING_MESSAGES[w.code]}
        </NoticeStrip>
      ))}
    </>
  );
}
